// extracted by mini-css-extract-plugin
module.exports = {"root":"_1nGUD","section":"_2PQFi","carouselContainer":"_1Cos-","errorBox":"_1Koiz","errorTitle":"_3nnSm","errorLink":"YPs3L"};